// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6022eb2d","391":"7f03cdff"}[chunkId] + ".chunk.js";
};